export const ADD_MENU = "ADD_MENU";
export const CHANGE_DRAWER = "CHANGE_DRAWER";
export const SET_SELECTED_MENU_ID = "SET_SELECTED_MENU_ID";
